import React, { useState } from 'react';
import _ from 'lodash';
import { Divider, Modal } from 'antd';
import MyButton from './Button';
import CustomerForm from './CustomerForm';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import GetProfile from './VariableStore';
import { instance } from './AxiosClient';
import { errorNotification, successNotification } from './Notification';
import { FormattedMessage, useIntl } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';

const CustomerModal = (props) => {
  const { isOpen, onCancle, isEdit, isSaveCustomer, createSearch, customerData, form, setEvent, tempDataCus, setTempDataCus, setIsTemp, isTemp } = props;
  const isDesktop = useIsDesktop();
  const intl = useIntl()



  const handleClickSave = async () => {
    const customerId = GetProfile('customerId');
    const comCode = GetProfile('customerCode');
    const contactId = _.get(customerData, 'customerContactId');
    const uuid = uuidv4();
    form
      .validateFields()
      .then(async (values) => {
        const body = {
          customerId: customerId,
          customerContactName: values.name,
          customerContactEmail: values.email,
          customerContactPhone: values.phone,
          remark: values.remark,
          // customerContactId: isTemp === false ? uuid : undefined,
          // isTemp: isTemp
        };
        // if (isTemp === false) {
        //   const newData = [...tempDataCus, body];
        //   //console.log('isTemp', newData);
        //   setTempDataCus(newData);
        //   form.resetFields();
        //   setEvent((current) => !current);
        //   setIsTemp(true)
        //   successNotification(intl.formatMessage({ id: 'saveSuccessNotification', defaultMessage: 'Success' }));
        // } else {
        try {
          const response = isEdit
            ? await instance.put(`/v3/business-partner/manager/company/${comCode}/customer-contacts/${contactId}`, body)
            : await instance.post(`/v3/business-partner/manager/company/${comCode}/customer-contacts`, body);
          setEvent((current) => !current);
          form.resetFields();
          successNotification(intl.formatMessage({ id: 'saveSuccessNotification', defaultMessage: 'Success' }));
        } catch (error) {
          // //console.log("error", error)
          errorNotification(intl.formatMessage({ id: 'saveErrorNotification', defaultMessage: 'Failed' }));
        }
        // }
        onCancle();
      })
      .catch((info) => {
        // //console.log('Validate Failed:', info);
      });
  };

  return (
    <Modal
      title={
        isEdit ? (
          <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
            <FormattedMessage id='modalEditCustomer' defaultMessage='Edit Customer' />
          </Typography>
        ) : (
          <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
            <FormattedMessage id='modalCreateCustomer' defaultMessage='Create Customer' />
          </Typography>
        )
      }
      maskClosable={false}
      open={isOpen}
      onOk={() => { }}
      onCancel={onCancle}
      zIndex={9999}
      width={428}
      bodyStyle={{ height: '80%' }}
      centered={isDesktop ? true : false}
      footer={[
        isDesktop ? (
          <>
            <MyButton
              onClick={onCancle}
              style={{
                width: isDesktop ? '25%' : '100%',
              }}
            >
              <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
            </MyButton>
            <MyButton
              isPrimary
              onClick={handleClickSave}
              style={{
                width: isDesktop ? '25%' : '100%',
              }}
            >
              {isEdit ? <FormattedMessage id='btnSave' defaultMessage='Save' /> : <FormattedMessage id='btnCreate' defaultMessage='Create' />}
            </MyButton>{' '}
          </>
        ) : (
          <div>
            <MyButton
              isPrimary
              onClick={handleClickSave}
              style={{
                width: isDesktop ? '25%' : '100%',
                marginInlineStart: '0px',
              }}
            >
              {isEdit ? <FormattedMessage id='btnSave' defaultMessage='Save' /> : <FormattedMessage id='btnCreate' defaultMessage='Create' />}
            </MyButton>{' '}

            <MyButton
              onClick={onCancle}
              style={{
                width: isDesktop ? '25%' : '100%',
                marginLeft: '0px',
                marginTop: '8px'
              }}
            >
              <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
            </MyButton>
          </div>
        )
      ]}
    >
      <Divider className='m-0' />
      <CustomerForm
        isEdit={isEdit}
        isSaveCustomer={isSaveCustomer}
        handleClickSave={handleClickSave}
        form={form}
        createSearch={createSearch}
        customerData={customerData}
        isOpen={isOpen}
        // isTemp={isTemp}
        setIsTemp={setIsTemp}
      />
    </Modal>
  );
};

export default CustomerModal;
